/* Maison Marrow — storefront behaviours (no dependencies) */
(function () {
  'use strict';
  var cfg = window.mmConfig || {};

  function fmt(cents) {
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + s;
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  function add(items, btn) {
    if (!items || !items.length) return Promise.resolve();
    var original = btn && btn.textContent;
    if (btn) { btn.setAttribute('disabled', ''); btn.textContent = 'Adding…'; }
    var body = {
      items: items,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.json.description || res.json.message || 'Could not add to cart'); }
        var d = drawer();
        if (d && typeof d.renderContents === 'function' && res.json.sections) {
          d.classList.remove('is-empty');
          d.renderContents(res.json);
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      })
      .catch(function (e) { window.alert(e.message); })
      .then(function () { if (btn) { btn.removeAttribute('disabled'); btn.textContent = original; } });
  }
  window.mmAdd = add;

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-mm-add]');
    if (q) {
      e.preventDefault();
      add([{ id: Number(q.getAttribute('data-mm-add')), quantity: 1 }], q);
      return;
    }
    var room = e.target.closest('[data-mm-room]');
    if (room) {
      e.preventDefault();
      var ids = room.getAttribute('data-mm-room').split(',').filter(Boolean);
      add(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), room);
      return;
    }
    var fbt = e.target.closest('[data-mm-fbt-add]');
    if (fbt) {
      e.preventDefault();
      var wrap = fbt.closest('.mm-fbt');
      var urlVariant = new URLSearchParams(window.location.search).get('variant');
      var items = [].slice.call(wrap.querySelectorAll('input[type=checkbox]:checked')).map(function (c) {
        var id = Number(c.getAttribute('data-variant'));
        if (c.hasAttribute('data-main') && urlVariant) { id = Number(urlVariant); }
        return { id: id, quantity: 1 };
      });
      add(items, fbt);
    }
  });

  /* FBT totals */
  function updateFbt(wrap) {
    var total = 0, compare = 0, n = 0;
    wrap.querySelectorAll('input[type=checkbox]').forEach(function (c) {
      if (c.checked) {
        n++;
        total += Number(c.getAttribute('data-price'));
        compare += Number(c.getAttribute('data-compare') || c.getAttribute('data-price'));
      }
    });
    var t = wrap.querySelector('[data-fbt-total]');
    var s = wrap.querySelector('[data-fbt-save]');
    var b = wrap.querySelector('[data-mm-fbt-add]');
    if (t) t.textContent = fmt(total);
    if (s) s.textContent = compare > total ? 'You save ' + fmt(compare - total) + ' vs. list price' : '';
    if (b) { b.textContent = n > 1 ? 'Add ' + n + ' items to cart' : (n === 1 ? 'Add item to cart' : 'Select an item'); if (!n) b.setAttribute('disabled', ''); else b.removeAttribute('disabled'); }
  }
  document.addEventListener('change', function (e) {
    var w = e.target.closest && e.target.closest('.mm-fbt');
    if (w) updateFbt(w);
  });
  document.querySelectorAll('.mm-fbt').forEach(updateFbt);

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.mm-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.mm-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Sticky add-to-cart on product pages */
  var sticky = document.getElementById('mm-sticky');
  if (sticky) {
    var form = document.querySelector('product-form .product-form__submit, .product-form__submit');
    if (form && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (en) {
        var visible = en[0].isIntersecting;
        var below = en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', !visible && below);
      });
      so.observe(form);
      sticky.querySelector('button').addEventListener('click', function () {
        if (form.disabled) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        form.click();
      });
    }
  }

  /* Recently viewed */
  var KEY = 'mm_recent_v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (err) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (err) { /* ignore */ } }
  var cur = document.querySelector('[data-mm-handle]');
  if (cur) {
    var h = cur.getAttribute('data-mm-handle');
    var list = read().filter(function (x) { return x !== h; });
    list.unshift(h);
    write(list.slice(0, 8));
  }
  var rv = document.getElementById('mm-recent');
  if (rv) {
    var handles = read().filter(function (x) { return !cur || x !== cur.getAttribute('data-mm-handle'); }).slice(0, 4);
    if (handles.length) {
      Promise.all(handles.map(function (hd) {
        return fetch(window.Shopify.routes.root + 'products/' + hd + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (ps) {
        ps = ps.filter(Boolean);
        if (!ps.length) return;
        var grid = rv.querySelector('.mm-grid');
        grid.innerHTML = ps.map(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
          return '<article class="mm-card"><a class="mm-card__media" href="' + p.url + '"><img loading="lazy" src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '"></a>' +
            '<div class="mm-card__body"><h3 class="mm-card__title"><a href="' + p.url + '">' + p.title.split(' ').slice(0, 7).join(' ') + '</a></h3>' +
            '<div class="mm-price"><span>' + fmt(p.price) + '</span>' + (p.compare_at_price > p.price ? '<s>' + fmt(p.compare_at_price) + '</s>' : '') + '</div></div></article>';
        }).join('');
        rv.hidden = false;
      });
    }
  }
})();


/* Sale countdown */
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    document.querySelectorAll('[data-mm-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-mm-countdown'));
      if (isNaN(end)) { el.hidden = true; return; }
      var ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; return; }
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var set = function (k, v) { var n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = pad(v); };
      set('d', d); set('h', h); set('m', m); set('s', sec);
    });
  }
  tick();
  setInterval(tick, 1000);
})();
